module.exports = {
  PAYMENT_REJECTED: 'PAYMENT_REJECTED',
  NOT_CONSENTED: 'NOT_CONSENTED',
  SETTLEMENT_COMPLETED: 'SETTLEMENT_COMPLETED',
  ERROR: 'ERROR'
};
